import styled from 'styled-components';

import {ms} from '../../../../../../../../styles';
import {Button} from '../../../../../../../../uikit/Button';
import {TextArea} from '../../../../../../../../uikit/TextArea';
import {View} from '../../../../../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(20)};
`;

export const Input = styled(TextArea)`
  height: ${ms(126)};
  width: 100%;
  resize: none;
`;

export const SubmitButton = styled(Button.V2).attrs({
  accentColor: 'static.accent.trackers',
  size: 'la',
})`
  width: 100%;
`;
